(function(){
    'use strict'

    angular
    .module('app.usuarios')
    .controller('CambiarPassword', CambiarPassword);

    CambiarPassword.$inject = ['$scope', '$animationsSrv', '$routeParams', 'UsuariosService', 'logger', '$location', 'UserInfoService'];

    function CambiarPassword($scope, $animationsSrv, $routeParams, UsuariosService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.usuarioId = $routeParams.id ? $routeParams.id : 0;
        vm.nombreUsuario = $routeParams.id ? $routeParams.nombre : '';

        if(vm.usuarioId == 0 || vm.nombreUsuario == ''){
            $location.path('/usuarios');
        }

        vm.save = function(){

            $scope.submitted = true;

            if($scope.cambiarPasswordForm.$valid){
                if($scope.cambiarPasswordForm.$dirty){
                    updatePassword();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
                
            }
            else{
                logger.error('Por favor corrija los datos');
            }
        
        };

        function updatePassword() {
            vm.usuario.id = vm.usuarioId;
            var promise = UsuariosService.changePassword(vm.usuario);
                
            promise
            .then(function(response){
                logger.success('Usuario modificado con éxito.');
                $location.path('/usuarios');
            })
            .catch(function(error){
                logger.error('Hubo un erro al modificar el usuario');
            }); 
        }

    }
})();